import * as React from 'react'

const SvgDownloadOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M11.0432 6.1426C11.3002 5.91014 11.7167 5.91014 11.9736 6.1426C12.2306 6.37505 12.2306 6.75194 11.9736 6.98439L8.46488 10.159C8.20795 10.3915 7.7914 10.3915 7.53447 10.159L4.0257 6.98439C3.76878 6.75194 3.76878 6.37505 4.0257 6.1426C4.28262 5.91014 4.69918 5.91014 4.9561 6.1426L7.34176 8.30105V2.35714C7.34176 2.1599 7.63631 2 7.99966 2C8.363 2 8.65755 2.1599 8.65755 2.35714V8.30108L11.0432 6.1426ZM2.16634 12.8333H13.833C14.2932 12.8333 14.6663 13.165 14.6663 13.5741C14.6663 13.9832 14.2932 14.3148 13.833 14.3148H2.16634C1.7061 14.3148 1.33301 13.9832 1.33301 13.5741C1.33301 13.165 1.7061 12.8333 2.16634 12.8333Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDownloadOutlined
